(function () {
    "use strict";
    angular.module("app")
        .service("permissionsService",
            [
                "$http", function ($http) {

                    this.GetClientDetails = function (clientId) {
                        return $http.get("api/permissions/clientDetails/" + clientId)
                            .then(function (response) {
                                return response.data;
                            }, function () {
                                throw ("Client Detail Retrieval Failure");
                            });
                    };

                    this.PostTokenRefresh = function (clientid, scopes, permissions) {
                        return $http.post("core/connect/InternalToken/",
                            { clientId: clientid, scopes: scopes, permissions: permissions })
                            .then(function (response) {
                                return response.data;
                            }, function () {
                                throw ("Client Detail Retrieval Failure");
                            });
                    };

                    this.GetAllClientsforAccount = function (accountId) {
                        return $http.get("api/permissions/AllClientsforAccount/" + accountId)
                            .then(function (response) {
                                return response.data;
                            }, function () {
                                throw ("Could Not get clients for account");
                            });
                    };


                    this.DeleteClientforAccount = function (accountClientId) {
                        return $http.delete("api/permissions/AccountClient/" + accountClientId)
                            .then(function (response) {
                                return response.data;
                            }, function () {
                                throw ("Could Not remove client form account");
                            });
                    }

                    this.GetAllClientsforCompany = function (companyId) {
                        return $http.get("api/permissions/AllClientsforCompany/" + companyId)
                            .then(function (response) {
                                return response.data;
                            }, function () {
                                throw ("Could Not get clients for company");
                            });
                    };

                    this.CreateCompanyClient = function (companyId, enviromentId, name, password) {
                        return $http.post("api/permissions/createCompanyClient",
                            { companyId: companyId, environmentId: enviromentId, name: name, password: password }
                        )
                            .then(function (response) {
                                return response.data;
                            }, function () {
                                throw ("Could create client for company");
                            });
                    }

                    this.DeleteCompanyClient = function (clientId) {
                        return $http.delete("api/permissions/CompanyClient/" + clientId)
                            .then(function (response) {
                                return response.data;
                            }, function () {
                                throw ("Could Not remove client form Company");
                            });
                    }

                    this.UpdateClientPassword = function (enviromentId, password) {
                        return $http.post("api/permissions/UpdateClientPassword/",
                            { environmentId: enviromentId, name: name, password: password })
                            .then(function (response) {
                                return response.data;
                            }, function () {
                                throw ("Could Not update client password");
                            });
                    }
                    this.ShowClientSecret = function (companyId ,password) {
                        return $http.post("api/permissions/SharedSecretForCompany/",
                            { companyId: companyId, environmentId: null, name: null, password: password })
                            .then(function (response) {
                                return response.data;
                            }, function () {
                                throw (response.data.message);;
                            });
                    }
                }
            ]);
})();